<template lang="pug">
.calendar-selection
  .dt-selection(v-if="selected.startDate && selected.endDate")
    v-date-picker(:value='selected.startDate' @dayclick="d => updateStartDate(d)" :popover="popoverConfig")
      template(v-slot='{ inputEvents }')
        input.dt-selection-date(:value='formatDate(selected.startDate)' v-on='inputEvents')
    .dt-selection-connect <->
    v-date-picker(:value='selected.endDate' @dayclick="d => updateEndDate(d)" :popover="popoverConfig")
      template(v-slot='{ inputValue, inputEvents }')
        input.dt-selection-date(:value='formatDate(selected.endDate)' v-on='inputEvents')
  .dt-controls
    .icon(@click="previousMonth()")
      svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1' stroke-linecap='round' stroke-linejoin='round')
        line(x1='19' y1='12' x2='5' y2='12')
        polyline(points='12 19 5 12 12 5')
    .middle
      b-select(@input="setYear($event)" :value="today.year")
        option(v-for="i in 3" :value="today.year + i - 1") {{today.year + i - 1}}
    .icon(@click="nextMonth()")
      svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1' stroke-linecap='round' stroke-linejoin='round')
        line(x1='5' y1='12' x2='19' y2='12')
        polyline(points='12 5 19 12 12 19')

  .calendar-wrapper
    .calendar-wrapper-month(v-for="i in calendarCount")
      CalendarMonth(:month="getMonth(i)"
                    :year="getYear(i)"
                    :selected="selected"
                    :mode="mode"
                    @selectedDate="(d) => selectDate(d, 'click')"
                    @hoverDate="(d) => selectDate(d, 'hover')"
                    :bookings="filterBookings(i)")
</template>

<script>
import ClickOutside from 'vue-click-outside'
import { DateTime } from 'luxon'
import CalendarMonth from '@/components/molecules/CalendarMonth'

export default {
  components: {
    CalendarMonth
  },
  directives: {
    ClickOutside
  },
  props: {
    bookings: {
      type: Array,
      default () {
        return []
      }
    },
    selected: {
      type: Object,
      default () {
        return {
          startDate: null,
          endDate: null
        }
      }
    },
    calendarCount: {
      type: Number,
      default: 2
    },
    currentDateOverride: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      mode: 'start',
      showYearDropdown: false,
      currentDate: DateTime.local(this.year, this.month),
      popoverConfig: {
        visibility: 'focus'
      }
    }
  },
  watch: {
    currentDateOverride() {
      this.currentDate  = this.currentDateOverride;
    }
  },
  computed: {
    today () {
      return this.booking && this.booking.startDate ? DateTime.fromISO(this.booking.startDate) : DateTime.local()
    },
    tooEarly () {
      if (this.currentDate < this.today) { return true }
      return false
    },
    tooLate () {
      if (this.currentDate.plus({ month: 2 }).year > this.today.year + 2) { return true }
      return false
    }
  },
  mounted() {
    if (this.currentDateOverride) {
      this.currentDate  = this.currentDateOverride;
    }
  },
  methods: {
    updateStartDate(d) {
      const newStartDate = DateTime.fromJSDate(d.date);
      if (this.selected.endDate.diff(newStartDate, 'days').toObject().days < 1) {
        return
      }
      this.$emit('updateStartDate', newStartDate);
      this.$emit('updateEndDate', this.selected.endDate);
    },
    updateEndDate(d) {
      const newEndDate = DateTime.fromJSDate(d.date);
      if (newEndDate.diff(this.selected.startDate, 'days').toObject().days <= 0) {
        return
      }
      this.$emit('updateEndDate', newEndDate);
    },
    formatDate(d) {
      const dt = DateTime.fromISO(d);
      return dt.setLocale('de')
        .toFormat("dd. LLLL yyyy")
    },
    nextMonth () {
      this.currentDate = this.currentDate.plus({ month: 1 })
    },
    previousMonth () {
      this.currentDate = this.currentDate.minus({ month: 1 })
    },
    setYear (e) {
      this.currentDate = this.currentDate.set({ year: e })
    },
    filterBookings (i) {
      const d = this.currentDate.plus({ month: i - 1 })
      return this.bookings.filter((b) => {
        return (
          (DateTime.fromISO(b.startDate).month === d.month &&
            DateTime.fromISO(b.startDate).year === d.year) ||
          (DateTime.fromISO(b.endDate).month === d.month &&
            DateTime.fromISO(b.endDate).year === d.year)
        )
      })
    },
    getMonth (i) {
      return this.currentDate.plus({ month: i - 1 }).month
    },
    getYear (i) {
      return this.currentDate.plus({ month: i - 1 }).year
    },
    startDateIsFree (d) {
      let blockedArrival = false
      let blockedDeparture = false
      let blocked = false
      for (let i = 0; i < this.bookings.length; i += 1) {
        const startDate = DateTime.fromISO(this.bookings[i].startDate)
        const endDate = DateTime.fromISO(this.bookings[i].endDate)

        if (
          startDate.year === d.year &&
          startDate.month === d.month &&
          startDate.day === d.day
        ) {
          // Check Start Date
          blockedArrival = true
        } else if (
          endDate.year === d.year &&
          endDate.month === d.month &&
          endDate.day === d.day
        ) {
          // Check End Date
          blockedDeparture = true
        } else if (startDate <= d && d <= endDate) {
          // Check inbetween Date
          // blocked = true
        }
      }

      // When arrival is blocked but departure free we can book this time
      if (blockedArrival) { return false }
      if (!blockedDeparture) { return true }

      if (blocked) { return false }
      return true
    },
    endDateIsFree (d) {
      let blockedArrival = false
      let blockedDeparture = false
      let blocked = 0

      // When enddate is before startdate we can quit right away
      if (d <= this.selected.startDate) { return false }

      for (let i = 0; i < this.bookings.length; i += 1) {
        const startDate = DateTime.fromISO(this.bookings[i].startDate)
        const endDate = DateTime.fromISO(this.bookings[i].endDate)

        if (
          startDate.year === d.year &&
          startDate.month === d.month &&
          startDate.day === d.day
        ) {
          // Check Start Date
          blockedArrival += 1
        } else if (
          endDate.year === d.year &&
          endDate.month === d.month &&
          endDate.day === d.day
        ) {
          // Check End Date
          blockedDeparture = true
        }

        // Check inbetween Date
        if (this.selected.startDate <= startDate && startDate <= d) {
          blocked += 1
        }
        if (this.selected.startDate <= endDate && endDate <= d) {
          blocked += 1
        }
      }

      // When departure is blocked but arrival free we can book this time
      if (blockedDeparture) { return false }
      if (!blockedArrival && blocked <= 1) { return true }

      if (blocked) { return false }
      return true
    },
    selectDate (d, selectType) {
      if (
        this.selected.startDate === null &&
        this.selected.endDate === null &&
        selectType === 'click'
      ) {
        if (this.startDateIsFree(d)) {
          this.$emit('updateStartDate', d)
          this.mode = 'hover'
        }
      } else if (
        (this.selected.startDate !== null && this.selected.endDate === null) ||
        (this.selected.startDate !== null && this.selected.endDate !== null)
      ) {
        if (
          this.endDateIsFree(d) &&
          selectType === 'click' &&
          this.mode === 'hover'
        ) {
          // We click during hover means we have a final selection
          this.$emit('updateEndDate', d)
          this.mode = 'end'
        } else if (
          this.startDateIsFree(d) &&
          selectType === 'click'
        ) {
          // We click after we have a final selection means we want to restart
          this.$emit('updateStartDate', d)
          this.$emit('updateEndDate', null)
          this.mode = 'hover'
        } else if (
          this.endDateIsFree(d) &&
          selectType === 'hover' &&
          this.mode === 'hover'
        ) {
          // We just hover and dont mutate the mode
          this.$emit('updateEndDate', d)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dt-selection {
  padding-top: $sm-space;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .dt-selection-date {
    padding: 4px 8px;
    border-radius: 3px;
    border: solid 1px $lightgray;
    font-size: 1rem;
    font-weight: 500;
  }
}
.dt-controls {
  padding-top: $sm-space;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  .icon {
    cursor: pointer;
    height: 100%;
    min-width: 56px;
    max-width: 56px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: white;
    border: solid 1px $lightgray;
    border-radius: 3px;
    &.disabled {
      pointer-events: none;
      opacity: 0.16;
      // background-color: $lightgray;
      // color: $gray;
    }
  }
  .middle {
    height: 100%;
    width: 100%;
    max-width: 96px;
    margin-bottom: $sm-space;
    .input {
      cursor: pointer;
      position: relative;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      background-color: white;
      border: solid 1px $lightgray;
      border-radius: 3px;
      font-weight: 500;
      width: 100%;
      height: 100%;
      text-align: center;

      svg {
        margin-left: $xs-space;
        color: $gray;
      }
    }
  }
}

.calendar-wrapper {
  margin: $sm-space 0;
  .calendar-wrapper-month {
    margin-bottom: $sm-space;
  }
  .calendar-wrapper-month:last-child {
    margin-bottom: 0;
  }
  @include md {
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
    .calendar-wrapper-month {
      margin-right: $sm-space;
    }
    .calendar-wrapper-month:last-child {
      margin-right: 0;
    }
  }
}
</style>
